import Image from "next/image";
import { reportError } from "@/core/lib/datadog/datadog";
import { useCheckFileExists } from "@/core/hooks/useCheckFileExists/useCheckFileExists";

const NOT_FOUND_IMAGE: string = "images/icons/airlines/not-found.svg";

interface AirlineIconProps {
  src: string;
  flightNumber: string;
}

const AirlineIcon = ({ src = "", flightNumber = "" }: AirlineIconProps) => {
  const { doesExist, error } = useCheckFileExists(src);

  if (!doesExist) {
    reportError(
      new Error(`Can not find airline for ${src}, for flight ${flightNumber}`)
    );
  }

  if (error) {
    throw Error(
      `Can not fetch the airline svg logo from public folder by the following path: ${src}`
    );
  }

  const iconSource = doesExist ? src : NOT_FOUND_IMAGE;

  return <Image src={iconSource} alt="airline-logo" width={35} height={35} />;
};

export default AirlineIcon;
